<script>
  import { onDestroy, onMount } from 'svelte';

  import { getProfileStore } from '@stores/profile';

  import UserAjax from '@ajax/user';
  import ComponentEvents from '@utils/component-events';

  import CollectionBarTile from './CollectionBarTile.svelte';
  import Sortable from 'sortablejs';
  import { browser } from '$app/environment';
  const AutoScroll = Sortable.AutoScroll;
  try {
    Sortable.mount(new AutoScroll());
  } catch {}

  export let user;
  export let tablet = false;
  export let mobile = false;

  import jQuery from 'jquery';
  let groupsStore = getProfileStore('groupsStore');
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let groupCollectionSortOrderStore = getProfileStore('groupCollectionSortOrderStore');
  let groupCollectionSortOrder = groupCollectionSortOrderStore;
  let groupCollections = [];

  if (groupCollectionSortOrder) {
    groupCollections = groupCollectionStore.withSortOrder(groupCollectionSortOrder.map((x) => x.value));

    if (!user.permissions.edit) {
      groupCollections = groupCollections.filter((x) => groupsStore.findByIds(x.group_base_sort_order).length > 0);
    }
  }

  let showFullCollectionsList = false;
  let sliceCount = mobile ? 9999 : tablet ? 6 : 8;

  let groupSorting = false;
  let mouseoverTimeout;

  let toggleShowAllCollections = () => {
    showFullCollectionsList = !showFullCollectionsList;
  };

  let setupCollectionSortable = function (node) {
    if (!browser) {
      return;
    }
    if (!user.permissions.edit || mobile) {
      return;
    }

    let sortFinished = function () {
      let ids = [];

      jQuery('[data-collection-bar-id]').each(function () {
        ids.push(jQuery(this).data('collection-bar-id'));
      });

      UserAjax.update(user, {
        group_collection_sort_order: ids,
      });

      groupCollectionSortOrderStore.set(ids);
      groupCollectionStore.runCallbacks();
    };

    let cachedShowFullCollectionsList;

    new Sortable(node, {
      group: 'collections-items',
      handle: '.profile-sections-content-item',
      forceFallback: true,
      fallbackOnBody: true,
      filter: '.undraggable',
      fallbackTolerance: 5,
      scrollSensitivity: 120,
      scrollSpeed: 20,
      scroll: false,
      onStart: function (evt) {
        cachedShowFullCollectionsList = showFullCollectionsList;
        showFullCollectionsList = true;

        jQuery(evt.item).children('.profile-sections-content-item').hide();
        jQuery(evt.item).children('.draggable-placeholder').show();
      },
      onSort: sortFinished,
      onEnd: function (evt) {
        showFullCollectionsList = cachedShowFullCollectionsList;
        jQuery(evt.item).children('.profile-sections-content-item').show();
        jQuery(evt.item).children('.draggable-placeholder').hide();
      },
    });
  };

  let unsubGroupSorting = ComponentEvents.on('profile-collection-bar-group-sorting', async (data) => {
    groupSorting = data.groupSorting;

    if (!groupSorting) {
      clearTimeout(mouseoverTimeout);
    }
  });

  onMount(() => {
    let subCollections = groupCollectionStore.subscribe((x) => {
      if (groupCollectionSortOrder) {
        groupCollections = x.withSortOrder(groupCollectionSortOrder.map((x) => x.value));
        if (!user.permissions.edit) {
          groupCollections = groupCollections.filter((x) => groupsStore.findByIds(x.group_base_sort_order).length > 0);
        }
      }
    });
    return () => {
      subCollections();
      unsubGroupSorting();
    };
  });

  onDestroy(() => {});
</script>

<style style="text/scss" lang="scss">
  * :global(.draggable-placeholder) {
    border: 2px dashed #aaa;
    background: #eee;
    opacity: 0.5;
    height: 100%;
    width: 100%;
    border-radius: 15px;
    display: none;
    min-height: 48px;
  }

  .profile-sections-content {
    display: grid;
    grid-template-columns: repeat(auto-fill, 244px);
    grid-gap: 8px;
    margin-bottom: 48px;
  }

  .profile-sections-content-item-container {
    height: 48px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 12px 64px -20px #333;
    border-radius: 8px;
    background-color: white;
  }

  .group-collections-toggle {
    cursor: pointer;
    width: 50px;
    display: inline-flex;
    float: right;
    margin-right: -75px;
    margin-top: 30px;
  }

  .group-sorting > div > :global(.profile-sections-content-item) {
    &:hover {
      border: 2px solid #a893f9 !important;
    }
  }

  @media only screen and (max-width: 1170px) {
    .profile-sections-content {
      grid-template-columns: repeat(auto-fill, 214px);
    }
  }
</style>

<div style="position: relative">
  {#if !mobile && groupCollections.length > sliceCount + 1}
    <div
      class:tablet={tablet}
      class="group-collections-toggle"
      on:click={() => {
        toggleShowAllCollections();
      }}>
      {#if !showFullCollectionsList}
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
            fill="#F8F6FF" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.7592 18.3492C24.3998 17.9299 23.7685 17.8813 23.3492 18.2407L20.5 20.6829L17.6508 18.2407C17.2314 17.8813 16.6001 17.9299 16.2407 18.3492C15.8813 18.7685 15.9299 19.3998 16.3492 19.7593L19.8492 22.7593C20.2237 23.0802 20.7763 23.0802 21.1508 22.7593L24.6508 19.7593C25.0701 19.3998 25.1187 18.7685 24.7592 18.3492Z"
            fill="#A893F9" />
        </svg>
      {:else}
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
            fill="#F8F6FF" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.2408 22.6508C16.6002 23.0701 17.2315 23.1187 17.6508 22.7593L20.5 20.3171L23.3492 22.7593C23.7686 23.1187 24.3999 23.0701 24.7593 22.6508C25.1187 22.2315 25.0701 21.6002 24.6508 21.2407L21.1508 18.2407C20.7763 17.9198 20.2237 17.9198 19.8492 18.2407L16.3492 21.2407C15.9299 21.6002 15.8813 22.2315 16.2408 22.6508Z"
            fill="#A893F9" />
        </svg>
      {/if}
    </div>
  {/if}

  {#if groupCollections.length > 1}
    <div
      class="profile-sections-content"
      class:group-sorting={groupSorting}
      use:setupCollectionSortable
      on:mouseenter={() => {
        if (groupSorting) {
          mouseoverTimeout = setTimeout(() => {
            showFullCollectionsList = true;
          }, 500);
        }
      }}
      on:mouseleave={() => {
        clearTimeout(mouseoverTimeout);
      }}>
      {#each groupCollections as collection, i (collection)}
        {#if collection.default_collection || (showFullCollectionsList == false && i > sliceCount)}
          <div data-collection-bar-id={collection.id} style="display: none;" />
        {:else}
          <div data-collection-bar-id={collection.id} style="clear: both;">
            <div class="draggable-placeholder">&nbsp;</div>
            <CollectionBarTile mobile={mobile} id={collection.id} user={user} groupSorting={groupSorting} />
          </div>
        {/if}
      {/each}
    </div>
  {/if}
</div>
